import {Component, DoCheck, HostBinding, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {HeaderComponent} from './header/header.component';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})

export class MainComponent implements OnInit {

  public pageTitle;
  @HostBinding('class') public bodyClasses = 'hold-transition skin-blue sidebar-mini';//sidebar-collapse
  //hold-transition skin-blue sidebar-mini sidebar-open //küçükken açık
  //hold-transition skin-blue sidebar-mini  //küçükken kapalı
  @ViewChild(HeaderComponent) headerComponent: HeaderComponent;
  public isMenuSidebarOpen = true;

  constructor(private activatedRoute: ActivatedRoute,
              private router: Router) {

  }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// /var/www/bizisystem-frontend/src/src/app/main/main.component.ts